let canvas = document.createElement("canvas");
canvas.width = 384;
canvas.height = 108;

function checkRect(data, colorThreshold, percent) {
  // let result = false;
  let out = 0;
  for (let i = 0, m = data.length; i < m; i += 4) {
    if (data[i] > colorThreshold) {
      out++;
      // result = true;
      // break;
    }
  }

  let result = out / (data.length / 4) >  1 - percent;
  console.log("result", result, out, data.length / 4 , out / (data.length / 4));
  return result;
}

/**
 * 含まれてたらtrue
 * @param kinsiImg
 * @param bgWidth
 * @param pos
 * @param crop
 * @returns {boolean}
 */
export function containRestrict(kinsi, bgWidth, pos, crop) {
  // console.log("kinsiImg.image", image, image.width, image.height);
  const ratio = kinsi.width / bgWidth;
  // console.log("ratio", ratio);
  const context = canvas.getContext("2d");

  context.drawImage(kinsi, 0, 0);

  const sx = Math.floor(pos.x * ratio);
  const sy = Math.floor(pos.y * ratio);
  const sw = Math.floor(crop.width * ratio);
  const sh = Math.floor(crop.height * ratio);
  const imageData = context.getImageData(sx, sy, sw, sh);
  const data = imageData.data;
  return checkRect(data, 10, 0.3);
}

export function initCheck() {}
